import LoadingButton from '@/components/Shared/LoadingButton'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
} from '@mui/material'
import React from 'react'
// import { YieldCurveShockTypes } from '@/enums/report.enum';
import { YieldCurveShockTypes } from '@/enums/scenario-builder.enum'

const KeyRatesToggleConfirmationModal: React.FC<{
  currentShockType: YieldCurveShockTypes
  setShockType: Function
  keyRatesToggleConfirmationModalOpened: boolean
  setKeyRatesToggleConfirmationModalOpened: Function
}> = ({
  currentShockType,
  setShockType,
  keyRatesToggleConfirmationModalOpened,
  setKeyRatesToggleConfirmationModalOpened,
}) => {
  const handleClose = () => {
    setKeyRatesToggleConfirmationModalOpened(false)
  }

  const confirmKeyRatesChange = () => {
    setShockType()
    handleClose()
  }

  return (
    <Dialog
      fullWidth
      maxWidth='xs'
      open={keyRatesToggleConfirmationModalOpened}
      onClose={handleClose}
      aria-labelledby='max-width-dialog-title'
      data-cy='key-rates-toggle-confirmation-modal'
    >
      <DialogTitle>Entry Type Change</DialogTitle>
      <Divider />
      <DialogContent>
        Are you sure you would like to switch to{' '}
        {currentShockType === YieldCurveShockTypes.KEY_RATES
          ? 'level / slope / curvature '
          : 'Key rates '}
        mode ?
      </DialogContent>

      <Divider />
      <DialogActions>
        <LoadingButton
          loading={false}
          onClick={confirmKeyRatesChange}
          color='error'
          data-cy='key-rates-toggle-confirmation-modal-confirm-button'
        >
          Confirm
        </LoadingButton>
        <Button
          onClick={handleClose}
          data-cy='key-rates-toggle-confirmation-modal-cancel-button'
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default KeyRatesToggleConfirmationModal
